
import { Component, Vue, Ref } from 'vue-property-decorator'
import { UserService } from '@/services/index'
import { roleOptions } from '@/constants/role'
import { UserStateStorage } from '@/common/utils'
import UserTable from './components/userTable.vue'
import ScrollTo from '@/components/scroll_to/index.vue'
import ScrollToType from '@/components/scroll_to/type'

@Component({
    name: 'UserList',
    components: {
        UserTable,
        ScrollTo
    }
})
export default class extends Vue {
    @Ref('scrollRef') private scrollEl!: ScrollToType
    private users = []
    private pageIndex = 1
    private pageSize = 20
    private pageTotal = 0
    private loading = true
    private roleOptions = roleOptions
    private queryParams = {
        name: '',
        department: '',
        role: undefined as number | undefined,
        mobile: '',
        email: ''
    }

    private mounted() {
        this.restoreState()
        this.getUsers()
    }

    private async getUsers() {
        this.loading = true
        const params: any = {
            page_index: this.pageIndex,
            page_size: this.pageSize
        }
        if (this.queryParams.name) params.name = this.queryParams.name
        if (this.queryParams.department) params.department = this.queryParams.department
        if (this.queryParams.role !== undefined && this.queryParams.role !== null) params.role = this.queryParams.role
        if (this.queryParams.mobile) params.mobile = this.queryParams.mobile
        if (this.queryParams.email) params.email = this.queryParams.email
        const result = await UserService.getUsers(params)
        this.loading = false
        if (result.status === 200) {
            this.users = result.data.users
            this.pageTotal = result.data.page_total
            this.saveState()
        }
    }

    private onSearch() {
        this.pageIndex = 1
        this.getUsers()
    }

    private onReset() {
        this.queryParams = {
            name: '',
            department: '',
            role: undefined,
            mobile: '',
            email: ''
        }
        this.pageIndex = 1
        this.getUsers()
    }

    private onRoleChange() {
        this.pageIndex = 1
        this.getUsers()
    }

    private onCurrentChange(page: number) {
        this.pageIndex = page
        this.getUsers()
    }

    private onCreate() {
        this.$router.push({ name: 'AdminUserCreate' })
    }

    private restoreState() {
        const saved = UserStateStorage.getState()
        if (Object.keys(saved).length > 0) {
            this.queryParams = {
                name: saved.name || '',
                department: saved.department || '',
                role: saved.role !== undefined ? saved.role : undefined,
                mobile: saved.mobile || '',
                email: saved.email || ''
            }
            this.pageIndex = saved.pageIndex || 1
        }
    }

    private saveState() {
        UserStateStorage.saveState({
            name: this.queryParams.name,
            department: this.queryParams.department,
            role: this.queryParams.role,
            mobile: this.queryParams.mobile,
            email: this.queryParams.email,
            pageIndex: this.pageIndex
        })
    }
}
